<template>
  <div class="student-side-menu">
    <div class="user-info">
      <a-avatar
        style="backgroundcolor: #87d068"
        icon="user"
        :src="getQiniuUrl(userInfo.avatar) || '/img/avatar.png'"
      />
      <h3>{{ userInfo.realname }}</h3>
      <p class="school-area" v-if="userCountInfo.mySchool">{{userCountInfo.mySchool.departName}}</p>
      <img src="@/assets/theme/xmw/xunzhang.svg" class="medal" alt="" />
      <p>优秀作业 {{userCountInfo.workGreatTotal}}</p>
      <p>(作业总数 {{userCountInfo.workTotal}})</p>
    </div>
    <a-divider style="width: 80%"></a-divider>
    <div>
      <a-menu mode="inline" @click="handleClick" v-model="selectedKeys">
        <a-menu-item key="studentCourse"
          ><router-link to="course"
            ><a-icon type="read" />我的课程</router-link
          ></a-menu-item
        >
        <a-menu-item key="studentWork"
          ><router-link to="work"
            ><a-icon type="code" />我的作业</router-link
          ></a-menu-item
        >
        <a-menu-item key="studentScore"
          ><router-link to="score"
            ><a-icon type="line-chart" />我的成绩</router-link
          ></a-menu-item
        >
        <a-menu-item key="greatWork"
          ><router-link to="greatWork"
            ><a-icon type="crown" />其他精选</router-link
          ></a-menu-item
        >
      </a-menu>
    </div>
  </div>
</template>

<script>
import { getAction } from '@/api/manage'

export default {
  name: "SideMenuStudent",
  data() {
    return {
      selectedKeys: ["course"],
      userCountInfo: {}
    };
  },
  created() {
    let that = this;
    this.userInfo = this.$store.state.user.info;
    this.selectedKeys[0] = this.$route.name;
    this.getUserCount()
  },
  methods: {
    handleClick(e) {},
    getQiniuUrl(text){
      if(!text){
        return;
      }
      if(text.indexOf(",")>0){
        text = text.substring(0,text.indexOf(","))
      }
      return window._CONFIG['qn_base'] + text;
    },
    getUserCount(){
      getAction("/teaching/user/countInfo").then(res=>{
        this.userCountInfo = res.result
      })
    }
  },
};
</script>

<style lang="less" scoped>
.student-side-menu {
  padding-bottom: 20px;
}
.user-info {
  background-image: url("~@assets/theme/xmw/user-info-bg.png");
  background-size: cover;
  padding-top: 50px;
  .school-area {
    font-size: 14px;
    color: #999;
  }
  .medal {
    width: 40px;
    margin-bottom: 10px;
  }
}
.ant-avatar {
  width: 80px;
  height: 80px;
  padding: 5px;
  background: #fff !important;
}
</style>